// extracted by mini-css-extract-plugin
export default {"mCard":"fG-z","image":"gG-z","imageNoBackground":"hG-z","fullWidth":"iG-z"};